import React, { useEffect, useState } from "react";
import { Space, Tag } from "antd";
import {
  EditOutlined,
  LockOutlined,
  MailOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import DataTable from "../../components/Comman/CustomTable/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import CategoryStatistics from "../../utils/Carousel";
import AdminDashboardDetails from "../../components/Comman/AdminDashboard/AdminDashboardDetails";
import { OrganizationListAction } from "../../actions/admin";
import AdminDashboardSocialLinks from "../../components/Comman/AdminDashboard/AdminDashboardSocialLinks";
import { getAdminDashboardData } from "../../actions/admin";
import SideDrawer from "../../components/Comman/Drawer/SideDrawer";
import {
  formatBackendDateToCST,
  formatMobileNumber,
  formatSubmissionValue,
} from "../../utils/comman";
import ConfirmDeleteModal from "../../components/Comman/ConfirmDeleteModal/ConfirmDeleteModal";
import {
  leaderUserListAction,
  submissionListAction,
  updateDataEntryForm,
} from "../../actions/user";

const Dashboard = () => {
  const dispatch = useDispatch<any>();
  const [data, setData] = useState<any[]>([]);
  const [submissionData, setSubmissionData] = useState<any[]>([]);
  const [userData, setUserData] = useState<any[]>([]);
  const [currentSubmission, setCurrentSubmission] = useState<any[]>([]);
  const [unlockingId, setUnlockingId] = useState<string>(null);
  const [isModalOpen, setIsModelOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [dashboardData, setDashboardData] = useState<any>({});
  const [deleteUserId, setDeleteUserId] = useState<string>(null);
  const [deleteModelVisible, setDeleteModelVisible] = useState<boolean>(false);
  const [selectedEntry, setSelectedEntry] = useState<any>(null);
  const [isDataEntryModelOpen, setIsDataEntryModelOpen] =
    useState<boolean>(false);
  const [sortConfig, setSortConfig] = useState<{
    field: string | null;
    order: "asc" | "desc" | null;
  }>({
    field: null,
    order: null,
  });
  const [sortDataUserConfig, setSortDataUserConfig] = useState<{
    field: string | null;
    order: "asc" | "desc" | null;
  }>({
    field: null,
    order: null,
  });
  const [sortSubmissionConfig, setSortSubmissionConfig] = useState<{
    field: string | null;
    order: "asc" | "desc" | null;
  }>({
    field: null,
    order: null,
  });
  const [sortCurrentSubmissionConfig, setSortCurrentSubmissionConfig] =
    useState<{
      field: string | null;
      order: "asc" | "desc" | null;
    }>({
      field: null,
      order: null,
    });
  const user = useSelector((state: any) => state?.Auth?.user);
  const roleId = user?.user?.roleId;
  const [isOrganizationModalOpen, setIsOrganizationModalOpen] =
    useState<boolean>(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 4,
    total: 0,
    totalPages: 0,
  });
  const [userPagination, setUserPagination] = useState({
    current: 1,
    pageSize: 4,
    total: 0,
    totalPages: 0,
  });
  const [submissionPagination, setSubmissionPagination] = useState({
    current: 1,
    pageSize: 4,
    total: 0,
    totalPages: 0,
  });
  const [curentSubmissionPagination, setCurrentSubmissionPagination] = useState(
    {
      current: 1,
      pageSize: 4,
      total: 0,
      totalPages: 0,
    }
  );
  const [selectedOrganization, setSelectedOrganization] = useState<any>(null);
  const handleRefresh = useSelector(
    (state: any) => state?.General?.updateListing
  );

  // useEffect to trigger API call when pagination state changes
  useEffect(() => {
    if (roleId === 1) {
      fetchOrganizationList({
        page: pagination.current, // Current page number
        limit: pagination.pageSize, // Number of records per page
      });
    } else if ([2, 3].includes(roleId)) {
      fetchDataUserList({
        page: userPagination.current, // Current page number
        limit: userPagination.pageSize, // Number of records per page
      });
      fetchDataSubmissionList({
        page: submissionPagination.current, // Current page number
        limit: submissionPagination.pageSize, // Number of records per page
      });
      fetchCurrentDataSubmissionList({
        page: curentSubmissionPagination.current, // Current page number
        limit: curentSubmissionPagination.pageSize, // Number of records per page
      });
    }
  }, [handleRefresh]);

  const handleModelState = (id?: any) => {
    if (id) setUnlockingId(id); // Store the selected user ID
    setIsModelOpen(!isModalOpen);
  };

  const handleEditClick = (record: any) => {
    handleIsOrganizationModelOpen();
    setSelectedOrganization(record); // Store the selected organization's data
  };

  const handleSubmissionEditClick = (record: any) => {
    handleIsDataEntryModelOpen();
    setSelectedEntry(record); // Store the selected organization's data
  };

  const handleIsDataEntryModelOpen: any = () => {
    setIsDataEntryModelOpen(!isDataEntryModelOpen);
  };

  const handleDeleteModel = (id?: string) => {
    if (id) setDeleteUserId(id); // Store the selected user ID
    setDeleteModelVisible(!deleteModelVisible);
  };

  const handleIsOrganizationModelOpen: any = () => {
    setIsOrganizationModalOpen(!isOrganizationModalOpen);
  };

  // Fetches the list of organizations with optional query parameters
  const fetchOrganizationList = (params = {}) => {
    setLoading(true); // Show loading indicator before making the API call
    const requestParams = {
      ...params,
      currentMonth: 1,
    };

    dispatch(
      OrganizationListAction(requestParams, (resp: any) => {
        setLoading(false); // Hide loading indicator once the API call is completed
        if (resp?.status === 200) {
          setData(resp.data || []); // Store the fetched organization data

          // Update pagination state based on API response
          setPagination({
            ...pagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
            totalPages: resp.pagination?.totalPages,
          });
        }
      })
    );
  };

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    let newSortConfig = { ...sortConfig };
    if (sorter && Object.keys(sorter).length > 0) {
      newSortConfig = {
        field: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      };
    }
    setSortConfig(newSortConfig);
    fetchOrganizationList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 4,
      ...(newSortConfig.field && newSortConfig.order
        ? {
            sort: newSortConfig.field,
            order: newSortConfig.order,
          }
        : {}),
    });
  };

  // Fetches admin dashboard data asynchronously
  const getDashboardData = async () => {
    try {
      const response: any = await dispatch(getAdminDashboardData(roleId)); // ✅ Dispatch and wait for response
      setDashboardData(response?.data); // ✅ Now `data` exists
    } catch (error) {
      console.log(error, "error from the admin dashboard");
    }
  };

  useEffect(() => {
    getDashboardData();
  }, []); // Empty dependency array ensures this runs only once on mount

  //Data User of this month -----------------------------------------------------------------------------

  const fetchDataUserList = (params = {}) => {
    setLoading(true); // Show loading indicator before making the API call
    const requestParams = {
      ...params,
      thisMonth: 1,
    };
    dispatch(
      leaderUserListAction(requestParams, (resp: any) => {
        setLoading(false); // Hide loading indicator once the API call is completed
        if (resp?.status === 200) {
          setUserData(resp?.data || []); // Store the fetched organization data

          // Update pagination state based on API response
          setUserPagination({
            ...userPagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
            totalPages: resp.pagination?.totalPages,
          });
        }
      })
    );
  };

  const handleDataUserTableChange = (
    pagination: any,
    filters: any,
    sorter: any
  ) => {
    let newSortConfig = { ...sortDataUserConfig };
    if (sorter && Object.keys(sorter).length > 0) {
      newSortConfig = {
        field: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      };
    }
    setSortDataUserConfig(newSortConfig);
    fetchDataUserList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 4,
      ...(newSortConfig.field && newSortConfig.order
        ? {
            sort: newSortConfig.field,
            order: newSortConfig.order,
          }
        : {}),
    });
  };

  const handleDataUserDeletion = () => {
    setLoading(true); // Show loading indicator before making the API call
    // dispatch(
    //   deleteBudget(selectedUserId, (resp: any) => {
    //     setLoading(false); // Hide loading indicator once the API call is completed
    //     if (resp?.status === 200) {
    //       // User deleted successfully, handle UI update if needed
    //       handleDeleteModel();
    //     } else {
    //       handleDeleteModel();
    //     }
    //   })
    // );
  };

  //Data Submission --------------------------------------------

  const fetchDataSubmissionList = (params = {}) => {
    setLoading(true); // Show loading indicator before making the API call
    const requestParams = {
      params,
      currentMonth: 1,
    };

    dispatch(
      submissionListAction(requestParams, (resp: any) => {
        setLoading(false); // Hide loading indicator once the API call is completed
        if (resp?.status === 200) {
          setSubmissionData(resp.data || []); // Store the fetched submission data
          // Update pagination state based on API response
          setSubmissionPagination({
            ...submissionPagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
            totalPages: resp.pagination?.totalPages,
          });
        }
      })
    );
  };

  const handleDataSubmissionTableChange = (
    pagination: any,
    filters: any,
    sorter: any
  ) => {
    let newSortConfig = { ...sortSubmissionConfig };
    if (sorter && Object.keys(sorter).length > 0) {
      newSortConfig = {
        field: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      };
    }
    setSortSubmissionConfig(newSortConfig);
    fetchDataSubmissionList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 4,
      ...(newSortConfig.field && newSortConfig.order
        ? {
            sort: newSortConfig.field,
            order: newSortConfig.order,
          }
        : {}),
    });
  };

  const handleReportUnlocking = () => {
    const payload = {
      SubmissionData_Update_Request: true,
      id: unlockingId,
    };
    dispatch(
      updateDataEntryForm(payload, (resp: any) => {
        handleModelState();
      })
    );
  };

  const getRowClassName = (record: any) => {
    return record?.SubmissionData_Status === "submitted" ? "faded-row" : "";
  };

  //Current data Submission list

  const fetchCurrentDataSubmissionList = (params = {}) => {
    setLoading(true); // Show loading indicator before making the API call
    const requestParams = {
      params,
      id: roleId,
      thisMonth: 1,
    };
    dispatch(
      submissionListAction(requestParams, (resp: any) => {
        setLoading(false); // Hide loading indicator once the API call is completed
        if (resp?.status === 200) {
          setCurrentSubmission(resp.data || []); // Store the fetched submission data
          // Update pagination state based on API response
          setCurrentSubmissionPagination({
            ...curentSubmissionPagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
            totalPages: resp.pagination?.totalPages,
          });
        }
      })
    );
  };

  const handleCurrentDataSubmissionTableChange = (
    pagination: any,
    filters: any,
    sorter: any
  ) => {
    let newSortConfig = { ...sortCurrentSubmissionConfig };
    if (sorter && Object.keys(sorter).length > 0) {
      newSortConfig = {
        field: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      };
    }
    setSortCurrentSubmissionConfig(newSortConfig);
    fetchCurrentDataSubmissionList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 4,
      ...(newSortConfig.field && newSortConfig.order
        ? {
            sort: newSortConfig.field,
            order: newSortConfig.order,
          }
        : {}),
    });
  };

  const columns = [
    {
      title: "Organization",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "Division of",
      dataIndex: "divisionOf",
      key: "divisionOf",
      render: (text, record) => {
        return record?.parentOrganization?.shortCode || "-";
      },
      sorter: true,
    },
    {
      title: "Contact Name",
      dataIndex: "primare_contact_name",
      key: "primare_contact_name",
    },
    {
      title: "Phone",
      dataIndex: "primare_contact_phone",
      key: "primare_contact_phone",
      render: (data) => formatMobileNumber(data),
    },
    {
      title: "Action",
      key: "action",
      render: (record: any) => (
        <Space size="middle">
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "16px" }}
          >
            <EditOutlined onClick={() => handleEditClick(record)} />
          </span>
        </Space>
      ),
    },
  ];

  const dataSubmissionColumns = [
    {
      title: "Org",
      dataIndex: "organizationName",
      key: "organization",
      render: (_, data) => data?.organization?.shortCode || "-",
    },
    {
      title: "DE",
      dataIndex: "dataElement",
      key: "dataElement",
      render: (dataElement: any) => dataElement?.DataElements_Name,
    },
    {
      title: "Category",
      dataIndex: "dataElement",
      key: "dataElement.category.id",
      render: (dataElement: any) => dataElement?.category?.name || "-",
    },
    {
      title: "Data Year",
      dataIndex: "SubmissionData_Year",
      key: "SubmissionData_Year",
    },
    {
      title: "Data Period",
      dataIndex: "SubmissionData_Period",
      key: "SubmissionData_Period",
      render: (_, record) =>
        record.SubmissionData_Period
          ? `${record.SubmissionData_IntervalType} ${
              record.SubmissionData_Period || "N/A"
            }`
          : "-",
    },
    {
      title: "Data Value",
      dataIndex: "SubmissionData_Value",
      key: "SubmissionData_Value",
      render: (value: string, record: any) => (
        <div className="text-right">
          {formatSubmissionValue(
            value,
            record?.dataElement?.DataElements_DataType
          )}
        </div>
      ),
    },
    {
      title: "Due On",
      dataIndex: "SubmissionData_CalculatedDueDate",
      key: "SubmissionData_CalculatedDueDate",
      render: (value) => formatBackendDateToCST(value),
    },
    {
      title: "Status",
      key: "status",
      render: (record: any) => (
        <>
          {record.SubmissionData_Status === "submitted" ? (
            <Tag color="green">Submitted</Tag>
          ) : record.SubmissionData_Status === "past due" ? (
            <Tag color="red">Past Due</Tag>
          ) : record.SubmissionData_Status === "pending" ? (
            <Tag color="yellow">Pending</Tag>
          ) : (
            <Tag color="default">Unknown</Tag> // Default case for unexpected values
          )}
        </>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (record: any) => (
        <Space size="middle">
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "20px" }}
          >
            <EditOutlined
              onClick={() => {
                if (record?.SubmissionData_Status !== "submitted")
                  handleSubmissionEditClick(record);
              }}
            />
          </span>
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "20px" }}
          >
            {record.SubmissionData_Status === "submitted" ? (
              <LockOutlined onClick={() => handleModelState(record?.id)} />
            ) : (
              <UnlockOutlined />
            )}
          </span>
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "20px" }}
          >
            <MailOutlined />
          </span>
        </Space>
      ),
    },
  ];

  const dataUsersColumns = [
    {
      title: "User Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Org Assignments",
      dataIndex: "organizationAssignment",
      key: "organizationAssignment",
      render: (_, record) => {
        const shortCodes = record?.organizationAssignment
          ?.map((item: any) => item?.organization?.shortCode)
          .filter(Boolean); // filter to avoid undefined/null

        return shortCodes?.length ? shortCodes.join(", ") : "-";
      },
    },
    {
      title: "Data Elements",
      dataIndex: "totalDataElementsCount",
      key: "totalDataElementsCount",
    },
  ];

  return (
    <div>
      {/* <Header /> */}

      <div className="flex flex-wrap gap-[22px] mt-2">
        <div className=" w-full lg:w-[calc(75%-11px)]  ">
          <AdminDashboardDetails data={dashboardData} />

          <CategoryStatistics />
          {roleId === 1 && (
            <div className="table-col rounded-[12px] bg-[#10151A]">
              <h3 className=" text-[12px] 2xl:text-sm text-[#919191] px-[20px] py-[15px]">
                Organizations Created This Month
              </h3>
              <DataTable
                columns={columns}
                data={data}
                loading={false}
                rowKey="id"
                pagination={{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  total: pagination.total,
                }}
                onTableChange={handleTableChange}
              />
            </div>
          )}
          {[2, 3].includes(roleId) && (
            <div className="leaderDashboardTables">
              <div className="table-col rounded-[12px] bg-[#10151A] mb-5">
                <h3 className=" text-[12px] 2xl:text-sm text-[#919191] px-[20px] py-[15px]">
                  My Current Data Submissions
                </h3>
                <DataTable
                  rowClassName={getRowClassName}
                  columns={dataSubmissionColumns}
                  data={submissionData}
                  loading={false}
                  rowKey="id"
                  pagination={{
                    current: submissionPagination.current,
                    pageSize: submissionPagination.pageSize,
                    total: submissionPagination.total,
                  }}
                  onTableChange={handleDataSubmissionTableChange}
                />
              </div>
              <div className="table-col rounded-[12px] bg-[#10151A] mb-5">
                <h3 className=" text-[12px] 2xl:text-sm text-[#919191] px-[20px] py-[15px]">
                  Data Users Of This Month
                </h3>
                <DataTable
                  columns={dataUsersColumns}
                  data={userData}
                  loading={false}
                  rowKey="id"
                  pagination={{
                    current: userPagination.current,
                    pageSize: userPagination.pageSize,
                    total: userPagination.total,
                  }}
                  onTableChange={handleDataUserTableChange}
                />
              </div>
              <div className="table-col rounded-[12px] bg-[#10151A]">
                <h3 className=" text-[12px] 2xl:text-sm text-[#919191] px-[20px] py-[15px]">
                  Current Data Submission For Organizations
                </h3>
                <DataTable
                  rowClassName={getRowClassName}
                  columns={dataSubmissionColumns}
                  data={currentSubmission}
                  loading={false}
                  rowKey="id"
                  pagination={{
                    current: curentSubmissionPagination.current,
                    pageSize: curentSubmissionPagination.pageSize,
                    total: curentSubmissionPagination.total,
                  }}
                  onTableChange={handleCurrentDataSubmissionTableChange}
                />
              </div>
            </div>
          )}
        </div>

        <AdminDashboardSocialLinks graphData={dashboardData} />
      </div>

      <SideDrawer
        open={isOrganizationModalOpen}
        onClose={handleIsOrganizationModelOpen}
        type={"organization"}
        organizationData={selectedOrganization} // Pass only selected record
      />
      {deleteModelVisible && (
        <ConfirmDeleteModal
          handleConfirmDeleteModel={handleDeleteModel}
          type="delete"
          handleModelFunction={handleDataUserDeletion}
        />
      )}
      {isModalOpen && (
        <ConfirmDeleteModal
          handleConfirmDeleteModel={handleModelState}
          type="reportUnlock"
          handleModelFunction={handleReportUnlocking}
        />
      )}
      <SideDrawer
        open={isDataEntryModelOpen}
        onClose={handleIsDataEntryModelOpen}
        type={"dataEntry"}
        organizationData={selectedEntry} // Pass only selected record
      />
    </div>
  );
};

export default Dashboard;
